var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthiopia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 13.4679 0.264047 14.874 0.746437 16.174L12 17.2174L23.2536 16.174C23.736 14.874 24 13.4679 24 12C24 10.5523 23.7435 9.16444 23.2737 7.87945L12 6.78262L0.726281 7.8795C0.256453 9.16444 0 10.5523 0 12H0Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C17.1596 24 21.5581 20.7435 23.2536 16.1739H0.746399C2.44191 20.7435 6.84043 24 12 24Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C6.84043 0 2.44191 3.2565 0.746399 7.82611H23.2537C21.5581 3.2565 17.1596 0 12 0Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.7391C15.1696 17.7391 17.7391 15.1696 17.7391 12C17.7391 8.83037 15.1696 6.26086 12 6.26086C8.83037 6.26086 6.26086 8.83037 6.26086 12C6.26086 15.1696 8.83037 17.7391 12 17.7391Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9988 7.55582L13.0348 10.7443H16.3928L13.6751 12.715L14.7192 15.913L11.9988 13.933L9.28244 15.9094L10.3224 12.715L7.60718 10.7443H10.9627L11.9988 7.55582Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1308 12.7936L12.8441 11.7256L14.8753 8.92997L14.0312 8.31656L11.9999 11.1124L9.96872 8.31661L9.1245 8.92992L11.1557 11.7258L7.86914 12.7935L8.19155 13.786L11.4782 12.7182V16.1739H12.5217V12.7181L15.8082 13.786L16.1308 12.7936Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthiopia);
export default __webpack_public_path__ + "static/media/ethiopia.602b718275f69965a964d6a7163338e0.svg";
export { ForwardRef as ReactComponent };